export enum UsageOrderBy {
    Time = 'time',
    Value = 'value',
}
